import './style.scss';
import CalculatorInit from '../CalculatorInit';

const init = options => {
  const defaultCalculatorOptions = {
    ID: '61',
    calculatorType: 'DefaultCalculator',
    parent: '[data-calc-short]',
    format: 'json',
    options: {
      deafault: {
        deadlinesDefault: [137189],
        academicLevelDefault: 1,
        pagesDefault: 1,
      },
    },
  };

  const calculatorOptions = {
    ...defaultCalculatorOptions,
    ...options,
  };

  CalculatorInit(calculatorOptions);
};

const ShortCalculator = options => {
  init(options);
};

export default ShortCalculator;
